import usePersistentState from '../providers/use-persistent-state';
import { appBarLinks, GlobalTabsKeysEnum } from '../providers/models/custom-app-links';

export enum ProfileOption {
  Full = 'full',
  Simplified = 'simplified',
}

export interface HomepageOption {
  name: string;
  value: GlobalTabsKeysEnum;
}

export const profileOptions = [
  { name: 'Full', value: ProfileOption.Full },
  { name: 'Simplified', value: ProfileOption.Simplified },
];

export const homepageOptions: HomepageOption[] = [
  { name: 'reloaded', value: '' as GlobalTabsKeysEnum },
  ...appBarLinks.map((link) => ({
    name: link.label,
    value: link.label as GlobalTabsKeysEnum,
  })),
];

export interface Preferences {
  profile: ProfileOption;
  homepage: GlobalTabsKeysEnum;
}

const defaultPreferences: Preferences = {
  profile: ProfileOption.Full,
  homepage: homepageOptions[0]?.value,
};

export function usePreferences() {
  const [preferences, setPreferences] = usePersistentState<Preferences>(
    ['user-preferences'],
    'preferences',
    defaultPreferences,
  );

  function setPreference<K extends keyof Preferences>(key: K, value: Preferences[K]) {
    setPreferences((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  return {
    preferences,
    setPreference,
    profileOptions,
    homepageOptions,
  };
}
